import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
  selector: 'date-viewer',
  templateUrl: './date-viewer.component.html',
  styleUrls: ['./date-viewer.component.scss']
})
export class DateViewerComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
